/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const STATS_TOOLTIP_ALL_TIME_STATS = (
    <FormattedMessage
        id='stats_tooltip.all_time_stats'
        defaultMessage='За всё время'
    />
)

export const STATS_TOOLTIP_28_DAYS_STATS = (
    <FormattedMessage
        id='stats_tooltip.28_days_stats'
        defaultMessage='За 28 дней'
    />
)

export const STATS_TOOLTIP_WIN_RATE = (
    <FormattedMessage
        id='stats_tooltip.win_rate'
        defaultMessage='Процент побед'
    />
)

export const STATS_TOOLTIP_SORTIES_COUNT = (
    <FormattedMessage
        id='stats_tooltip.sorties_count'
        defaultMessage='Количество боёв'
    />
)
export const STATS_TOOLTIP_FORT_BATTLES_COUNT = (
    <FormattedMessage
        id='stats_tooltip.fort_battles_count'
        defaultMessage='Количество Наступлений'
    />
)


export const STATS_TOOLTIP_NO_SORTIES = level => (
    <FormattedMessage
        id='stats_tooltip.no_sorties'
        defaultMessage='Клан не проводил Вылазки {level} дивизиона'
        values={{ level }}
    />
)
export const STATS_TOOLTIP_NO_FORT_BATTLES = (
    <FormattedMessage
        id='stats_tooltip.no_fort_battles'
        defaultMessage='Клан не проводил Наступления'
    />
)

export const STATS_TOOLTIP_FORT_BATTLES = (
    <FormattedMessage
        id='stats_tooltip.fort_battles'
        defaultMessage='Наступления'
    />
)

export const STATS_TOOLTIP_NO_STATS = level => (
    <FormattedMessage
        id='stats_tooltip.no_stats'
        defaultMessage='Клан не проводил сражения на {level} дивизионе'
        values={{ level }}
    />
)

export const STATS_TOOLTIP_HEADER = level => (
    <FormattedMessage
        id='stats_tooltip.header'
        defaultMessage='Сражения на {level} уровне'
        values={{ level }}
    />
)



// WEBPACK FOOTER //
// ./components/StatsTable/constants.jsx